"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockRetailClientFactory = void 0;
// factory for RetailClient
require("reflect-metadata");
const inversify_1 = require("inversify");
const mockContainer_1 = require("./mockContainer");
const RetailClient_1 = require("../client/RetailClient");
class RetailClientMock extends RetailClient_1.RetailClient {
}
__decorate([
    (0, inversify_1.inject)("MockConfiguration")
], RetailClientMock.prototype, "mockConfiguration", void 0);
function mockRetailClientFactory(apiUrl = "", config) {
    // create an IoC container
    const container = (0, mockContainer_1.createContainer)();
    // get an instance of RetailClient
    const retailClient = container.resolve(RetailClientMock);
    if (config) {
        // Setting a session for different access level based on config
        retailClient.mockConfiguration.setConfig(config);
        retailClient.auth.setSession(null);
    }
    retailClient.httpConnection.url = apiUrl;
    retailClient.webSocketConnection.setUrl(apiUrl);
    return retailClient;
}
exports.mockRetailClientFactory = mockRetailClientFactory;
//# sourceMappingURL=retailClientFactory.js.map